export default class HeaderController {
	constructor() {
		this.floatingHeaderElement = null;
		this.headerElement = null;
		this.menuButton = null;
		this.closeMenuButton = null;
		this.flyoutBackground = null;

		this.init();
		this.resize();
	}

	init() {
		this.floatingHeaderElement = document.querySelector('.floatingHeader');
		this.headerElement = document.querySelector('header');
		this.menuButtons = document.querySelectorAll('.menuButton');
		this.closeMenuButton = document.querySelector('.closeMenuButton');
		this.flyoutBackground = document.querySelector('.flyoutMenuBackground');

		// Register events
		// window.app.registerResizeEvent(this.resize.bind(this));
		window.app.registerScrollEvent(this.scroll.bind(this));

		// Click events
		this.menuButtons.forEach(button => button.addEventListener('click', this.toggleMenu.bind(this)));
		this.closeMenuButton.addEventListener('click', this.closeMenu.bind(this));
		this.flyoutBackground.addEventListener('click', this.closeMenu.bind(this));

		// this.headerElement.querySelectorAll('.flyout ul button').forEach(button => {
		// 	button.addEventListener('click', this.toggleSubMenu.bind(this, button));
		// });

		window.addEventListener('keydown', e => {
			if (e.key.substr(0, 3).toLowerCase() == 'esc') {
				this.closeMenu();
			}
		});
	}

	toggleMenu() {
		document.body.classList.toggle('flyoutActive');
	}

	closeMenu() {
		document.body.classList.remove('flyoutActive');
	}

	resize() {
		this.previousScroll = window.pageYOffset;

		this.scroll();
	}

	scroll() {

		if (document.querySelector('.homepage')) {
			if (window.pageYOffset > (this.floatingHeaderElement.clientHeight + 560)) {
				document.body.classList.add('menuActive');
			} else {
				document.body.classList.remove('menuActive');
			}
		} else {
			if (window.pageYOffset > (this.floatingHeaderElement.clientHeight)) {
				document.body.classList.add('menuActive');
			} else {
				document.body.classList.remove('menuActive');
			}
		}
	}

	hide() {
		this.headerElement.classList.add('hidden');
	}

	show() {
		this.headerElement.classList.remove('hidden');
	}
}